import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { globalVariable } from 'src/app/globalVariable/globalvariable';
import { CommonService } from 'src/app/services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { BrowserCompatablityComponent } from '../browser-compatablity/browser-compatablity.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;

  constructor(private fb: FormBuilder,
    private commonServ: CommonService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      username: ["", Validators.required],
      password: ["", Validators.required]
    })
  }

  ngOnInit(): void {
    this.commonServ.callingpublickey().subscribe((val) => {
      console.log("val", val)
      if (val.hasOwnProperty("publicKey")) {
        const publicKeyBase64 = val['publicKey'];
        globalVariable.publickey = publicKeyBase64;
        sessionStorage.setItem("publicKey", publicKeyBase64);
      }
    })
  }

  showBrowserCompatablity() {
    this.dialog.open(BrowserCompatablityComponent, {});
  }

  showNotice() {
    this.router.navigate(['/public-documents'])

  }
  showGeneralTnC() {
    this.router.navigate(['/public-documents'])

  }
  showPrivacyPolicy() {
    this.router.navigate(['/public-documents'])

  }

  login() {
    let formData = {
      "loginId": this.loginForm.value["username"],
      "password": this.loginForm.value["password"]
    }

    this.commonServ.validateLogin(formData, "For login").subscribe(
      (response) => {
        if (!(response == null || response == undefined)) {
          if (response["RESULT"] == "VALID") {
            console.log(response);
            this._snackBar.open('Logged in', "Close", {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
            });
            if (response["user_uuid"] != null) {
              console.log("jwttoken",response["jwttoken"])
              sessionStorage.setItem("uuid", response["user_uuid"])
              sessionStorage.setItem("jwttoken", response["jwttoken"])
              sessionStorage.setItem("user_name", response["user_name"])
              sessionStorage.setItem("isLoggedIn", 'true')
              sessionStorage.setItem("role_name", response["role_name"])
              globalVariable.role_name = response["role_name"]
              console.log("templae1", globalVariable.role_name)


            }
            this.router.navigate(['/home'])
          } else {
            this._snackBar.open(response["msg"], "Close", {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
            });
          }
        }
      }, (err) => {
        console.log(err);

      }
    )

  }
  //   this.commonServ.validateLogin(formData,"For login").subscribe(
  //     (response) => {
  //       if (!(response == null || response == undefined)) {
  //         if (response["RESULT"] == "VALID") {
  //       console.log(response);
  //       this._snackBar.open('Logged in', "Close");
  //       if (response["tenant_uuid"] != null) {
  //         sessionStorage.setItem("uuid", response["tenant_uuid"])
  //       }
  //       this.router.navigate(['/'])
  //         }
  //       }
  //     }, (err) => {
  //       console.log(err);

  //     }
  //   )

  // }

}